import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  Card,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableContainer,
  Typography,
  Dialog,
  DialogTitle,
  IconButton,
  DialogContent,
  Button,
  CircularProgress,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@mui/material';
import { CheckBoxOutlined, ZoomIn } from '@mui/icons-material';
import {
  ActionCell,
  DynamicTable,
  TableSearch
} from 'src/components/DynamicTable/DynamicTable';
import CloseIcon from '@mui/icons-material/Close';
import { Sellers } from '../../../interface/interface';
import LogoSpinner from 'src/components/LogoSpinner';
import { useAuth } from 'src/hooks/useAuth';
import { API } from '../../../config/config';
import SellersDetailsModal from '../../../components/Seller/SellersDetailsModal';
import { AsyncImage } from '../../../components/AsyncImage/AsyncImage';

interface SellersProps {
  isLoading: boolean;
  sellers: Sellers[];
  fetchData: () => void;
  reload: boolean;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;

  setSellersData: React.Dispatch<React.SetStateAction<Sellers[]>>;
}
const SellersContent: React.FC<SellersProps> = ({
  sellers,
  isLoading,
  fetchData,
  reload,
  setReload,
  setSellersData
}) => {
  // const { enhancedFetch } = useAuth();
  const [searchData, setSearchData] = useState<Sellers[] | null>(null);
  const [open, setOpen] = useState(false);
  const [currentSeller, setCurrentSeller] = useState<Sellers | null>(null);

  function onClose() {
    setOpen(false);
  }

  // sorting functionality
  const sortedSellers = [...sellers].sort((a, b) => {
    if (a.name > b.name) return 1; // Sort in ascending order
    if (a.name < b.name) return -1;
    return 0;
  });

  // look at this component again and tweak: there's something wrong there:
  if (isLoading)
    return (
      <Card>
        <div
          style={{
            height: '100vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <LogoSpinner />
        </div>
      </Card>
    );

  return (
    <Card>
      <TableContainer>
        <DynamicTable
          searchElement={
            <TableSearch
              placeholder="Search for sellers..."
              searchData={sellers}
              setSearchData={setSearchData}
            />
          }
          headers={[
            { headerName: 'Name', field: 'name' },
            { headerName: 'Email', field: 'email' },
            {
              headerName: 'Status',
              field: 'active', renderCell: ({row}) => (
                <Box
                  className="pill-button"
                >
                  {row.active ? 'Active' : 'InActive'}
                </Box>
              )
            },
            { headerName: 'Company', field: 'company' },
            { headerName: 'Logo', field: 'businessLogo',
              renderCell: (value) => <AsyncImage w={100} h={100} url={value.row.businessLogo} /> },
            { headerName: 'Phone', field: 'phoneNumber' },
            { headerName: 'Address', field: 'addressLine1' },
            {
              headerName: 'Actions',
              field: 'actions',
              renderCell: ({ row }) => (
                <ActionCell
                  deleteEndpoint={`${API.HOST}/api/v1/sellers/${row.id}`}
                  payload={row}
                  callback={() => setReload(!reload)}
                >
                  <IconButton
                    onClick={() => setCurrentSeller(row.actions)}
                    color="inherit"
                    size="small"
                  >
                    <ZoomIn fontSize="small" />
                  </IconButton>
                </ActionCell>
              )
            }
          ]}

          rows={sellers.map((seller) => ({
                id: seller.id,
                name: seller.name,
                email: seller.email,
                active: seller.active,
                company: seller.company,
                businessLogo: seller.businessLogo,
                phoneNumber: seller.phoneNumber,
                addressLine1: seller.addressLine1,
                actions: seller

            }))}
        />

        {/*SELLERS DETAILS MODAL*/}
        <SellersDetailsModal
          fetchData={fetchData}
          currentSeller={currentSeller}
          setCurrentSeller={setCurrentSeller}
        />
      </TableContainer>
    </Card>
  );
};

export default SellersContent;
